var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodraftcollection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "610.42px",
    height: "362px",
    viewBox: "0 0 610.42 362",
    style: {
      enableBackground: "new 0 0 610.42 362"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#44BAC5;}\n\t.st1{fill:#222931;}\n\t.st2{fill:#45B9C5;}\n\t.st3{fill:none;}\n\t.st4{opacity:0.6196;}\n\t.st5{fill:#EFEEEF;}\n\t.st6{fill:#FFFFFF;stroke:#222931;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st7{fill:#C6E5E6;stroke:#222931;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st8{fill:#45B9C5;stroke:#222931;stroke-width:2;stroke-miterlimit:10;}\n\t.st9{fill:#C6E9ED;stroke:#222931;stroke-miterlimit:10;}\n\t.st10{fill:#C6E9ED;stroke:#222931;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st11{fill:#45B9C5;stroke:#222931;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 181.5,
    y: 318.28,
    className: "st0",
    width: 107.7,
    height: 27.89
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.5,
    y: 269.33,
    className: "st0",
    width: 230.66,
    height: 27.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.23,
    y: 294.3,
    className: "st0",
    width: 22,
    height: 27.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.5,
    y: 165.26,
    className: "st0",
    width: 278.73,
    height: 27.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.5,
    y: 112.26,
    className: "st0",
    width: 216,
    height: 27.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.57,
    y: 60.26,
    className: "st0",
    width: 268.44,
    height: 27.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.57,
    y: 12.26,
    className: "st0",
    width: 175.66,
    height: 27.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.01,
    y: 60.26,
    className: "st0",
    width: 19.81,
    height: 27.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504.21,
    y: 190.26,
    className: "st0",
    width: 42,
    height: 27.95
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 181.5,
    cy: 332.28,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 287.5,
    cy: 332.28,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 76.5,
    cy: 283.28,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 307.23,
    cy: 283.28,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 369.23,
    cy: 308.28,
    r: 14
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M273.15,318.28c-5.72,0-10.35-4.69-10.35-10.47c0-5.78,4.63-10.47,10.35-10.47c0.12,0,0.23,0.01,0.35,0.02 v-7.55h-82.98v7.36c0.43-0.05,0.86-0.08,1.3-0.08c5.72,0,10.35,4.8,10.35,10.74s-4.63,10.74-10.35,10.74 c-0.44,0-0.87-0.03-1.3-0.08v0.33h82.98v-0.55C273.39,318.26,273.27,318.28,273.15,318.28z"
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 391.23,
    cy: 308.28,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 450.01,
    cy: 255.33,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 125.57,
    cy: 232.23,
    r: 14
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.57,189.23v3.97c6.9,0,12.5,5.61,12.5,12.53c0,6.92-5.6,12.53-12.5,12.53v0.97h320.64v-30H139.57z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M177.72,240.83v5.42c0.12,0,0.24-0.02,0.37-0.02c6.38,0,11.55,5.17,11.55,11.55s-5.17,11.55-11.55,11.55 c-0.12,0-0.25-0.01-0.37-0.02v0.52h272v-29H177.72z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M422.01,218.47v-0.21h-1.4C421.08,218.3,421.55,218.37,422.01,218.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M419.56,241.3c-6.38,0-11.55-5.17-11.55-11.55c0-6.03,4.61-10.97,10.5-11.5H125.57v27.95h296.44v-5.17 C421.22,241.21,420.4,241.3,419.56,241.3z"
  })))), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 460.21,
    cy: 204.23,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 504.21,
    cy: 204.23,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 546.21,
    cy: 204.23,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 90.5,
    cy: 179.23,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 181.5,
    cy: 126.23,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 153.57,
    cy: 74.23,
    r: 14
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M354.46,60.26c-5.53,0-10.01-4.48-10.01-10.01s4.48-10.01,10.01-10.01c0.26,0,0.51,0.02,0.76,0.04v-5.04 H237.76v5.01c5.36,0.19,9.64,4.59,9.64,10c0,5.41-4.28,9.82-9.64,10.01v2.93h117.46v-2.96 C354.97,60.24,354.72,60.26,354.46,60.26z"
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 201.57,
    cy: 26.23,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 377.23,
    cy: 26.23,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 422.01,
    cy: 74.23,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 464.01,
    cy: 74.23,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 483.81,
    cy: 74.23,
    r: 14
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M594.21,245.58v-9c0-1.1,0.9-2,2-2l0,0c1.1,0,2,0.9,2,2v9H594.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M594.21,261v-9h4v9c0,1.1-0.9,2-2,2l0,0C595.1,263,594.21,262.1,594.21,261z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M599.42,246.79h9c1.1,0,2,0.9,2,2l0,0c0,1.1-0.9,2-2,2h-9V246.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M584,246.79h9v4h-9c-1.1,0-2-0.9-2-2l0,0C582,247.69,582.9,246.79,584,246.79z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M12.21,245.58v-9c0-1.1,0.9-2,2-2h0c1.1,0,2,0.9,2,2v9H12.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M12.21,261v-9h4v9c0,1.1-0.9,2-2,2h0C13.1,263,12.21,262.1,12.21,261z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M17.42,246.79h9c1.1,0,2,0.9,2,2l0,0c0,1.1-0.9,2-2,2h-9V246.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2,246.79h9v4H2c-1.1,0-2-0.9-2-2l0,0C0,247.69,0.9,246.79,2,246.79z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M543.77,328.13v-7.93c0-0.64,0.52-1.16,1.16-1.16h0.99c0.64,0,1.16,0.52,1.16,1.16v7.93H543.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M543.77,341.37v-7.93h3.31v7.93c0,0.64-0.52,1.16-1.16,1.16h-0.99 C544.29,342.53,543.77,342.01,543.77,341.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M548.08,329.13h7.93c0.64,0,1.16,0.52,1.16,1.16v0.99c0,0.64-0.52,1.16-1.16,1.16h-7.93V329.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M534.84,329.13h7.93v3.31h-7.93c-0.64,0-1.16-0.52-1.16-1.16v-0.99 C533.68,329.65,534.2,329.13,534.84,329.13z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62.8,328.13v-7.93c0-0.64,0.52-1.16,1.16-1.16h0.99c0.64,0,1.16,0.52,1.16,1.16v7.93H62.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62.8,341.37v-7.93h3.31v7.93c0,0.64-0.52,1.16-1.16,1.16h-0.99C63.32,342.53,62.8,342.01,62.8,341.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.11,329.13h7.93c0.64,0,1.16,0.52,1.16,1.16v0.99c0,0.64-0.52,1.16-1.16,1.16h-7.93V329.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M53.87,329.13h7.93v3.31h-7.93c-0.64,0-1.16-0.52-1.16-1.16v-0.99C52.72,329.65,53.23,329.13,53.87,329.13z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M527.36,54.81v-7.24c0-0.64,0.52-1.16,1.16-1.16h0.74c0.64,0,1.16,0.52,1.16,1.16v7.24H527.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M527.36,66.95v-7.24h3.05v7.24c0,0.64-0.52,1.16-1.16,1.16h-0.74C527.87,68.1,527.36,67.59,527.36,66.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M531.33,55.73h7.24c0.64,0,1.16,0.52,1.16,1.16v0.74c0,0.64-0.52,1.16-1.16,1.16h-7.24V55.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M519.19,55.73h7.24v3.05h-7.24c-0.64,0-1.16-0.52-1.16-1.16v-0.74C518.04,56.25,518.55,55.73,519.19,55.73z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M83.04,54.81v-7.24c0-0.64,0.52-1.16,1.16-1.16h0.74c0.64,0,1.16,0.52,1.16,1.16v7.24H83.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M83.04,66.95v-7.24h3.05v7.24c0,0.64-0.52,1.16-1.16,1.16h-0.74C83.55,68.1,83.04,67.59,83.04,66.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M87.01,55.73h7.24c0.64,0,1.16,0.52,1.16,1.16v0.74c0,0.64-0.52,1.16-1.16,1.16h-7.24V55.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M74.87,55.73h7.24v3.05h-7.24c-0.64,0-1.16-0.52-1.16-1.16v-0.74C73.72,56.25,74.23,55.73,74.87,55.73z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M488.07,118.09v-5.75c0-0.64,0.52-1.16,1.16-1.16h0.2c0.64,0,1.16,0.52,1.16,1.16v5.75H488.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M488.07,127.87v-5.75h2.51v5.75c0,0.64-0.52,1.16-1.16,1.16h-0.2C488.59,129.03,488.07,128.51,488.07,127.87 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M491.34,118.85h5.75c0.64,0,1.16,0.52,1.16,1.16v0.2c0,0.64-0.52,1.16-1.16,1.16h-5.75V118.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M481.55,118.85h5.75v2.51h-5.75c-0.64,0-1.16-0.52-1.16-1.16V120C480.4,119.36,480.92,118.85,481.55,118.85z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M122.39,118.09v-5.75c0-0.64,0.52-1.16,1.16-1.16h0.2c0.64,0,1.16,0.52,1.16,1.16v5.75H122.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M122.39,127.87v-5.75h2.51v5.75c0,0.64-0.52,1.16-1.16,1.16h-0.2C122.9,129.03,122.39,128.51,122.39,127.87z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M125.66,118.85h5.75c0.64,0,1.16,0.52,1.16,1.16v0.2c0,0.64-0.52,1.16-1.16,1.16h-5.75V118.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M115.87,118.85h5.75v2.51h-5.75c-0.64,0-1.16-0.52-1.16-1.16V120C114.72,119.36,115.23,118.85,115.87,118.85 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M556.35,159.51v-8.26c0-0.64,0.52-1.16,1.16-1.16h1.11c0.64,0,1.16,0.52,1.16,1.16v8.26H556.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M556.35,173.26V165h3.42v8.26c0,0.64-0.52,1.16-1.16,1.16h-1.11C556.87,174.42,556.35,173.9,556.35,173.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M560.81,160.54h8.26c0.64,0,1.16,0.52,1.16,1.16v1.11c0,0.64-0.52,1.16-1.16,1.16h-8.26V160.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M547.06,160.54h8.26v3.42h-8.26c-0.64,0-1.16-0.52-1.16-1.16v-1.11 C545.9,161.06,546.42,160.54,547.06,160.54z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.17,159.51v-8.26c0-0.64,0.52-1.16,1.16-1.16h1.11c0.64,0,1.16,0.52,1.16,1.16v8.26H58.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.17,173.26V165h3.42v8.26c0,0.64-0.52,1.16-1.16,1.16h-1.11C58.68,174.42,58.17,173.9,58.17,173.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62.62,160.54h8.26c0.64,0,1.16,0.52,1.16,1.16v1.11c0,0.64-0.52,1.16-1.16,1.16h-8.26V160.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.87,160.54h8.26v3.42h-8.26c-0.64,0-1.16-0.52-1.16-1.16v-1.11C47.72,161.06,48.23,160.54,48.87,160.54z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "266.16,26.94 279.2,12.26 370.87,30.09 358.28,44.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "307.67,119.97 321.31,106.68 288.01,31.52 266.16,26.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "398.57,138.92 402.59,121.73 321.31,106.68 307.67,119.97  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "398.57,138.92 412.65,123.8 370.87,30.09 358.28,44.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "290.99,229.27 278.5,123.8 378.56,145.91 355.68,208.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "290.99,229.27 278.5,123.8 207.34,177.38 220.2,225.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "220.09,266.88 207.34,177.38 307.67,199.05 321.31,287.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "321.31,287.48 307.67,199.05 378.29,145.91 390.53,232.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "321.31,106.68 288.01,31.52 358.28,44.1 390.53,119.97  "
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodraftcollection);
export default __webpack_public_path__ + "static/media/No draft collection.921ea4eab89adb7155dd7af82e4607b7.svg";
export { ForwardRef as ReactComponent };